import script from "./CountBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./CountBadge.vue?vue&type=script&setup=true&lang=js"

import "./CountBadge.vue?vue&type=style&index=0&id=54b434be&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b434be"]])

export default __exports__